import AppointmentProductDetails from '@/components/appointment-product-details';
import ConfirmationDialog from '@/components/confirmation-dialog';
import ConfirmationDialogProgrammatic from '@/components/confirmation-dialog-programmatic';
import Datepicker from '@/components/date-picker';
import ClientMergeDetailWithLookup from '@/components/plugins/client-merge-detail-with-lookup';
import NationalInsuranceNumberInput from '@/components/plugins/national-insurance-number-input';
import OriginalSourceSelect from '@/components/plugins/original-source-select';
import PartnerPracticeSelect from '@/components/plugins/partner-practice-select';
import TriStateInput from '@/components/plugins/tri-state-input';
import UserSelect from '@/components/plugins/user-select';
import Snackbar from '@/components/snackbar';
import Stepper from '@/components/stepper';
import Tabs from '@/components/tabs';
import Vue, { PluginObject, VueConstructor } from 'vue';

const plugin: PluginObject<any> = {
    install: (vue: VueConstructor<any>, options?: any): void => {
        Vue.use(AppointmentProductDetails);
        Vue.use(ConfirmationDialog);
        Vue.use(ConfirmationDialogProgrammatic);
        Vue.use(Datepicker);
        Vue.use(ClientMergeDetailWithLookup);
        Vue.use(NationalInsuranceNumberInput);
        Vue.use(OriginalSourceSelect);
        Vue.use(PartnerPracticeSelect);
        Vue.use(TriStateInput);
        Vue.use(UserSelect);
        Vue.use(Snackbar);
        Vue.use(Stepper);
        Vue.use(Tabs);
    },
};

Vue.use(plugin);

export default plugin;
